module.exports = __webpack_public_path__ + "img/dsj.68d91557.png";